import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Agent, AgentConfigRequest, AgentResponse, CreditsSpent, DeleteFollowUpResponse, } from '@trendbuild/trend-gpt-maker-api/src/lib/models/agent.types';
import { ObjectResponse } from '@trendbuild/trend-gpt-maker-api/src/lib/models/base.request';
import { CreateOrEditIntentionRequest, DeleteIntentionResponse, IntentionRequest, IntentionResponse, } from '@trendbuild/trend-gpt-maker-api/src/lib/models/intentions.types';
import { TimeRequest, TrainingListItem, TrainingResponse, TrainingResponseList, } from '@trendbuild/trend-gpt-maker-api/src/lib/models/training.types';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { TrendGPTFollowUpRequest, TrendGPTFollowUpResponse } from '../models/trendgpt-follow-up.model';

@Injectable({ providedIn: 'root' })
export class AgentTrendGPTService extends AbstractService<Agent> {

  getURLBase(): string {
    return '/integration/trendGpt';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Agent): void { }
  preUpdate(obj: Agent): void { }

  createAgent(payload: Agent): Observable<Agent> {
    return super.post('/agent', payload);
  }

  getAgentById(agentId: string): Observable<Agent> {
    return super.get(`/agent/${agentId}`);
  }

  updateAgentById(agentId: string, payload: Agent): Observable<Agent> {
    return super.put(`/agent/${agentId}`, payload);
  }

  deleteAgentById(agentId: string): Observable<void> {
    return super.delete(`agent/${agentId}`);
  }

  inactiveAgent(agentId: string): Observable<AgentResponse> {
    return super.put(`/agent/${agentId}/inactive`, {});
  }

  activeAgent(agentId: string): Observable<AgentResponse> {
    return super.put(`/agent/${agentId}/active`, {});
  }

  getConfigById(agentId: string): Observable<AgentConfigRequest> {
    return super.get(`/agent/${agentId}/settings`);
  }

  updateConfigById(agentId: string, config: AgentConfigRequest): Observable<AgentConfigRequest> {
    return super.put(`/agent/${agentId}/settings`, config);
  }

  getCreditsSpent(agentId: string, query: TimeRequest): Observable<CreditsSpent> {
    return super.getWithParams(`/agent/${agentId}/credits`, query);
  }

  getTrainingByAgentId(agentId: string, query: TrainingListItem): Observable<TrainingResponseList> {
    return super.getWithParams(`/agent/${agentId}/training`, query);
  }

  createTrainingText(agentId: string, payload: TrainingListItem): Observable<TrainingResponse> {
    return super.post(`/agent/${agentId}/training/text`, payload)
  }

  createTrainingSite(agentId: string, payload: TrainingListItem): Observable<TrainingResponse> {
    return super.post(`/agent/${agentId}/training/site`, payload);
  }

  createTrainingVideo(agentId: string, payload: TrainingListItem): Observable<TrainingResponse> {
    return super.post(`/agent/${agentId}/training/video`, payload);
  }

  createTrainingDocument(agentId: string, payload: TrainingListItem): Observable<TrainingResponse> {
    return super.post(`/agent/${agentId}/training/document`, payload);
  }

  editTrainingById(trainingId: string, payload: TrainingListItem): Observable<TrainingResponse> {
    return super.put(`/training/${trainingId}`, payload);
  }

  deleteTrainingById(trainingId: string): Observable<void> {
    return super.delete(`training/${trainingId}`);
  }

  getIntentionsByAgentId(agentId: string, query: IntentionRequest): Observable<ObjectResponse<IntentionResponse>> {
    return super.getWithParams(`/agent/${agentId}/intentions`, query);
  }

  createIntentionByAgentId(agentId: string, payload: CreateOrEditIntentionRequest): Observable<IntentionResponse> {
    return super.post(`/agent/${agentId}/intentions`, payload);
  }

  editIntentionById(intentionId: string, payload: CreateOrEditIntentionRequest): Observable<IntentionResponse> {
    return super.put(`/intentions/${intentionId}`, payload);
  }

  deleteIntentionById(intentionId: string): Observable<void> {
    return super.delete(`intentions/${intentionId}`);
  }

  getFollowUpById(agentId: string): Observable<TrendGPTFollowUpResponse> {
    return super.get(`/agent/${agentId}/follow-up`);
  }

  createFollowUpById(agentId: string, payload: TrendGPTFollowUpRequest): Observable<TrendGPTFollowUpResponse> {
    return super.post(`/agent/${agentId}/follow-up`, payload);
  }

  updateFollowUpById(agentId: string, payload: TrendGPTFollowUpRequest): Observable<TrendGPTFollowUpResponse> {
    return super.put(`/agent/${agentId}/follow-up`, payload);
  }

  deleteFollowUpById(agentId: string): Observable<void> {
    return super.delete(`agent/${agentId}/follow-up`);
  }
}
